import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import { FeedListComponent } from './feed-list/feed-list.component';
// import { ViewMembersComponent } from './view-members/view-members.component';
// import { ViewGroupsComponent } from './view-groups/view-groups.component';
import {FeedRoutingModule } from './feed-routing.module';
import {ComposeMessageModule}  from './compose-message/compose-message.module';
import {SharedModule} from './../shared/shared.module';
import {FeedPipe} from './feed.search';

@NgModule({
  imports: [
    CommonModule,
    ComposeMessageModule,
    SharedModule,
    SlimScrollModule,
    FeedRoutingModule
  ],
  declarations: [FeedListComponent,  FeedPipe]
})
export class FeedModule { }



// WEBPACK FOOTER //
// ./src/app/feed/feed.module.ts